import React from "react";
import { motion } from "framer-motion";
import { Pikorua } from "./Pikorua";
import { Overline } from "./Reveal";

export const PageHero = ({ overline, title, subtitle }) => (
  <section className="relative bg-navy overflow-hidden pt-36 pb-20 md:pt-44 md:pb-24">
    <div className="absolute inset-0 noise-overlay" />
    <Pikorua className="absolute -right-10 -top-10 w-96 h-96 text-gold opacity-[0.07]" stroke="#F2A900" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      {overline && (
        <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <Overline className="text-gold">{overline}</Overline>
        </motion.div>
      )}
      <motion.h1
        initial={{ opacity: 0, y: 25 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="font-heading text-white text-5xl sm:text-6xl md:text-7xl font-medium tracking-tighter leading-[0.95] mt-5"
      >
        {title}
      </motion.h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="text-white/70 text-lg md:text-xl mt-6 max-w-2xl leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
